import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DateTime } from 'luxon';
import { PtLuxonDate } from '../../../../models/projects/date.models';
import { DateService } from '../../../../services/date/date.service';

@Component({
  selector: 'pt-date-time-combined-input',
  templateUrl: 'pt-date-time-combined-input.html'
})

// combines pt-luxon-date-picker, pt-time-input, and pt-offset picker into one easy to use component
export class PtDateTimeCombinedInputComponent {
  // shared inputs
  @Input() loading: boolean;
  @Input() disabled: boolean;
  @Input() ptLuxonDate: PtLuxonDate;

  // pt-time-input inputs
  // if luxonDate is null, we need some other date to check time is valid when user types in the text input - typically this will normally be DailyLogDate
  @Input() baseDate: DateTime;

  // pt-luxon-date-picker inputs
  @Input() datePickerName: string;
  @Input() datePickerInputWidth: number; // width in px
  @Input() min: DateTime;
  @Input() max: DateTime;

  // pt-time-input outputs
  @Output() inputBlurred: EventEmitter<boolean> = new EventEmitter();

  // shared output - gets emitted on changing date, or time, or offset
  @Output() dateTimeChanged: EventEmitter<PtLuxonDate> = new EventEmitter();

  constructor(private dateService: DateService) {

  }

  // called when user changes datepicker date
  async onDateChange(value: DateTime) {
    if (!value) {
      this.ptLuxonDate.dateTime = null;
      this.dateTimeChanged.emit(this.ptLuxonDate);
      return;
    }

    const timeToKeep = this.ptLuxonDate.dateTime.toFormat('HH:mm');
    const validationResult = await this.dateService.validateDateTime(timeToKeep, value);
    this.ptLuxonDate = validationResult && validationResult.isValid
      ? validationResult.ptLuxonDate
      : new PtLuxonDate(null, true);
    this.dateTimeChanged.emit(this.ptLuxonDate);
  }

  // onValueChange(date: DateTime) {
  //   this.valueChange.emit(date);
  // }

  // called when user clicks out of time input
  timeInputBlurred() {
    this.inputBlurred.next(true);
  }

  onTimeChange(ptLuxonDate: PtLuxonDate) {
    this.ptLuxonDate = ptLuxonDate; // update this.ptLuxonDate so attached pt-luxon-date-picker will update
    this.dateTimeChanged.next(ptLuxonDate);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/components/pt-date-time-combined-input/pt-date-time-combined-input.ts